import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';

interface AccordionSectionProps {
    seccion: {
        id: number;
        titulo: any;
        descripcion?: any;
    };
    required?: boolean;
    Children: React.ReactNode;
    initiallyExpanded?: boolean;
    bgColor?: string;
    summaryBgColor?: string;
    summaryColor?: string;
    rightButton?: boolean;
    rightButtonText?: string;
    onRightButtonClick?: any;
    testID?: string;
}

const CustomAccordion: React.FC<AccordionSectionProps> = ({
    seccion,
    initiallyExpanded = false,
    Children,
    required = false,
    bgColor = '#FFFFFF',
    summaryBgColor = '#476773',
    summaryColor = 'white',
    rightButton = false,
    rightButtonText,
    onRightButtonClick,
    testID = ''
}) => {
    const [expanded, setExpanded] = useState(initiallyExpanded);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleChange} elevation={0} data-testid={testID}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: summaryColor }} />}
                aria-controls={`panel${seccion.id}-content`}
                id={`panel${seccion.id}-header`}
                sx={{ backgroundColor: summaryBgColor, color: summaryColor, fontWeight: 600 }}
            >
                <Typography>{seccion.titulo}</Typography>
                {required && (
                    <Typography component="span" color="#D32F2F" lineHeight={1} fontSize={'24px'}>
                        *
                    </Typography>
                )}
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: bgColor }}>
                <Grid container spacing={2} sx={{ p: 2 }}>
                    {seccion.descripcion && (
                        <Grid item xs={10} sx={{ mb: 2 }}>
                            <Typography>{seccion.descripcion}</Typography>
                        </Grid>
                    )}
                    {rightButton && (
                        <Grid
                            item
                            xs={2}
                            sx={{ display: 'flex', justifyContent: 'flex-end', height: 60 }}
                        >
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={onRightButtonClick ? onRightButtonClick : () => {}}
                            >
                                {rightButtonText}
                            </Button>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        {Children}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default CustomAccordion;

